<template>
    <div>
        <sub-menu-call-center ativo="bloqueio" v-if="!cc" />

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            type="button-group"
                            :optionsList="[{ id: 'A', search: 'Ativos'}, { id: 'T', search: 'Todos'}]"
                            v-model="escopo" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input 
                            type="button-group"
                            :optionsList="[{ id: 'P', search: 'Período'}, { id: 'H', search: 'Horário Específico'}]"
                            v-model="tipo_bloqueio" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-9">
                        <az-input icon="fas fa-search fa-fw" v-model="search" @onEnter="load(false)" />
                    </div>

                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-success" @click="incluir ()" :disabled="tipo_bloqueio == 'H'">
                            Incluir Bloqueio
                        </button>
                    </div>
                </div>

            </div>

        </div>


        <div v-if="( !lista || !lista.length )" class="mt-3">
            <az-empty-state 
                :msg="'Nenhum bloqueio identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Bloqueio'" 
                :method="incluir" />
		</div>

        <div v-else>
            <div class="progress mt-1 mb-3">
                <div class="indeterminate" v-if="$store.state.loading && dados"></div>
                <div class="determinate" v-else></div>
            </div>
        </div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="mr-3">
                            {{ dado.medico ? dado.medico.search : 'TODOS' }}
                        </span>
                        <small class="text-muted mr-3">
                            {{ dado.bloqueio_motivo.search }}
                        </small>
                        <span v-if="dado.filtros && dado.filtros.length">
                            <i class="fa fa-filter" aria-hidden="true"></i>
                            <span class="badge badge-secondary">
                                {{ dado.filtros.length }}
                            </span>
                        </span>
                        <span v-if="!dado.fl_ativo" class="ml-3 badge badge-danger">
                            REMOVIDO
                        </span>
                    </span>
                    <div>
                        <h5 class="mb-0">
                            <span class="badge badge-secondary mr-2">
                                #{{ dado.id_bloqueio }}
                            </span>
                            <a href="#" class="card-link" @click.prevent="listaBloqueio (dado)"
                                data-toggle="tooltip" data-placement="top" title="Lista de marcações."
                                v-if="dado.marcacaos_count && dado.marcacaos_count.qtd">
                                <span class="badge badge-danger">
                                    {{ dado.marcacaos_count.qtd }}
                                </span>
                            </a>
                        </h5>
                    </div>
                </li>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="bloqueioModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Bloqueio
                            {{ item.id_bloqueio ? '#' + item.id_bloqueio : 'Novo' }}
                            <span v-if="item && !item.fl_ativo" class="ml-3 badge badge-danger">
                                REMOVIDO
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <template v-if="!cc">
                                    <template v-if="!item.id_bloqueio">
                                        <div class="d-flex flex-column">
                                            <az-input
                                                type="button-group"
                                                :optionsList="[
                                                    { id: 'M', search: 'Agenda Específica' },
                                                    { id: 'R', search: 'Recurso' },
                                                    { id: 'T', search: 'Todas as Agendas' }
                                                ]"
                                                optionsData="id"
                                                v-model="item.tipo" />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-if="item.id_bloqueio && !item.id_medico">
                                            <az-input
                                                type="label"
                                                label="Todas as Agendas..." />
                                        </div>
                                    </template>
                                </template>

                                <az-input
                                    v-if="( item.id_bloqueio && item.id_medico ) || ( item.tipo == 'M' )"
                                    label="Agenda"
                                    placeholder="Selecione o Agenda..."
                                    type="select"
                                    optionsMode="aql"
                                    service="medicos.index"
                                    :optionsName="'medicos-cadastro' + ( cc ? '.cc' : '' ) + ( infusao ? '.infusao' : '' )"
                                    optionsData="id_pessoa"
                                    :optionsParm="{ 
                                        ativos: true, 
                                        cc: cc, 
                                        infusao: infusao 
                                    }"
                                    required
                                    :validate="validate"
                                    :edicao="!item.id_bloqueio"
                                    v-model="item.id_medico" />

                                <az-input
                                    v-else-if="( item.tipo == 'R' )"
                                    label="Recurso"
                                    placeholder="Selecione o Recurso..."
                                    type="select"
                                    optionsMode="aql"
                                    service="equipamentos.index"
                                    optionsData="id_equipamento"
                                    required
                                    :validate="validate"
                                    v-model="item.id_equipamento" />

                                <!-- ( item.id_bloqueio && item.id_recurso ) ||  -->
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Início"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="item.dt_inicio"
                                    :edicao="!item.id_bloqueio"
                                    @input="ajuste_data_final()" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Fim"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    :edicao="!item.id_bloqueio"
                                    :rules="item.id_bloqueio ? [] : ['futuro']"
                                    v-model="item.dt_termino" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário Inicial"
                                    type="time"
                                    required 
                                    :validate="validate"
                                    :edicao="!item.id_bloqueio"
                                    v-model="item.hora_inicio" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Horário Final"
                                    type="time"
                                    required 
                                    :edicao="!item.id_bloqueio"
                                    :validate="validate"
                                    v-model="item.hora_termino" />
                            </div>
                        </div>

                        <!-- Seleção de Dias -->

                        <template v-if="item.dt_inicio && item.dt_termino && item.dt_inicio < item.dt_termino && ( !item.id_bloqueio || item.fl_dias )">
                            <div class="form-row mt-2">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Selecionar Dias da Semana"
                                        type="checkbox-group"
                                        :edicao="!item.id_bloqueio"
                                        :validate="validate"
                                        v-model="item.fl_dias"
                                        @click="prepara_dias()" />
                                </div>

                                <div class="col col-12 col-md-6 d-flex flex-column" v-if="item.fl_dias && item.js_dias && item.js_dias.dias">
                                     <div class="btn-group mb-0" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-sm" :disabled="item.id_bloqueio > 0"
                                            :class="item.js_dias.dias[dia - 1] ? 'btn-secondary' : 'btn-outline-secondary'" 
                                            @click="toggle_dia(dia - 1)"
                                            v-for="dia in 7" :key="dia">
                                            {{ nome_dia(dia - 1) }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                                
                        <!-- Filtros -->
                        <filtro-model 
                            class="my-3" 
                            v-model="item.filtros" 
                            :validate="validate" 
                            :opcoes="lista_opcoes_filtro" 
                            :viewonly="item.id_bloqueio" />

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Motivo"
                                    type="select"
                                    optionsMode="aql"
                                    optionsData="id_bloqueio_motivo"
                                    service="bloqueio_motivos.index"
                                    required 
                                    :edicao="!item.id_bloqueio"
                                    :validate="validate"
                                    v-model="item.id_bloqueio_motivo" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :edicao="!item.id_bloqueio"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação Interna (Não exibida no Call Center)"
                                    type="textarea"
                                    rows="3"
                                    :edicao="!item.id_bloqueio"
                                    v-model="item.st_observacao_interna" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="bloqueio" :id="item.id_bloqueio" v-if="item.id_bloqueio" />
                        <az-submit color="outline-danger" v-if="item.id_bloqueio && item.fl_ativo" @click="remover ()">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()" v-if="!item.id_bloqueio">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="bloqueioRealizadoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="bloqueio_realizado">
                    <div class="modal-header">
                        <h5 class="modal-title">Bloqueio</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row d-flex justify-content-center">
                            <div class="col display-4 my-3 text-center">
                                <div>
                                    <span>
                                        <i class="fas fa-ban fa-3x text-danger mb-3"></i>
                                    </span>
                                </div>
                                <div class="display-4">
                                    <span v-if="bloqueio_realizado.marcacaos_count">
                                        {{ bloqueio_realizado.marcacaos_count.qtd }}
                                        {{ bloqueio_realizado.marcacaos_count.qtd == 1 ? 'marcação afetada' : 'marcações afetadas' }}
                                    </span>
                                    <span v-else>
                                        Bloqueio Realizado
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-danger" @click="listaBloqueio (bloqueio_realizado)"
                            v-if="bloqueio_realizado.marcacaos_count && bloqueio_realizado.marcacaos_count.qtd > 0">
                            Visualizar Bloqueados
                        </button>
                    </div>
                </div>
            </div>
        </div>
        

        <pre v-if="1 == 0">{{ dados }}</pre>
    </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuCallCenter from './SubMenuCallCenter.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            item: null, 
            viewMode: 'A',
            search: "",
            validate: false, 
            escopo: "A",
            abrindo: false, 
            bloqueio_realizado: null, 
            filtros: { 
                periodo: "m", 
            },
            tipo_bloqueio: 'P',
        }
    },

    watch: { 
        escopo: function () { 
            this.load ();
        }
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados ? 
                this.dados.filter (item => { 
                    return ( this.escopo != 'A' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }

            if ( this.infusao ) { 
                opcoes.push({id:'App\\azure\\local', search:'Poltrona', service:'locals.index', parms: { cc: true, infusao: true }});
            } else if ( this.cc ) { 
                opcoes.push({id:'App\\azure\\local', search:'Sala', service:'locals.index', parms: { cc: true }});
            } else { 
                opcoes.push({id:'App\\azure\\local', search:'Coleta Domiciliar', service:'locals.index', parms: { dom: true }});
            }
            
            return opcoes; 
        }
    },

    props: ['cc', 'infusao'], 

    components: { 
        SubMenuCallCenter,
        AzInput, 
        AzSubmit,
        AzAuditLogButton, 
        FiltroModel,
        AzPeriodo
    },

    methods: { 
        nome_dia (dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }
        },

        toggle_dia (dia) { 
            this.$set(this.item.js_dias.dias, dia, !this.item.js_dias.dias[dia]);    
            console.log('js_dias', this.item.js_dias);
        }, 

        prepara_dias () { 
            if ( !this.item.js_dias ) { 
                this.item.js_dias = { 
                    dias: [false,false,false,false,false,false,false]
                };
            }
        },

        ajuste_data_final() { 
            if ( this.abrindo )
                return;

            this.item.dt_termino = this.item.dt_inicio;
        },

        listaBloqueio (item) { 

            $('[data-toggle="tooltip"]').tooltip('dispose');
            $('.modal').modal('hide');

            this.$router.push({ 
                name: 'confirmacao', 
                params: { 
                    pInicio: item.dt_inicio,
                    pTermino: item.dt_termino,
                    pStatus: 'B', 
                    pMedico: item.id_medico,
                    pIdBloq: item.id_bloqueio, 
                }
            });
            
        },

        atualizar () { 

            if ( this.item.tipo == 'T' ) { 
                this.item.id_medico = null;
            }

            this.$util.atualizar (this, { 
                service: 'bloqueios',
                dados: { 
                    ...this.item,
                    mais_30_dias: moment(this.item.dt_inicio).add(31, "days").format('YYYY-MM-DD'), 
                },
                modal: 'bloqueioModal',
                reload: true, 
                callback: res => { 
                    this.bloqueio_realizado = res;
                    $('#bloqueioRealizadoModal').modal('show');
                }
            });

        },

        remover () { 

            this.$util.atualizar(this, { 
                service: 'bloqueios',
                dados: { 
                    ...this.item, 
                    mais_30_dias: moment(this.item.dt_inicio).add(31, "days").format('YYYY-MM-DD'), 
                    fl_ativo: 0, 
                },
                modal: 'bloqueioModal',
                reload: true, 
            });

            /*
            this.$util.remover (this, { 
                service: 'bloqueios',
                dados: this.item,
                modal: 'bloqueioModal',
                reload: true, 
            });
            */

        },

        incluir () { 

            let item = { 
                id_bloqueio: null, 
                id_medico: "", 
                dt_inicio: null,
                dt_termino: null, 
                hora_inicio: '00:00',
                hora_termino: '23:59',
                fl_ativo: true, 
                filtros: [], 
                tipo: 'M', 
                st_observacao: "",
                st_observacao_interna: "", 
                fl_dias: false,
                js_dias: null,
            };

            this.editar (item);

        },

        editar (item) { 
            this.validate = false;
            this.abrindo = true;
            this.item = { ...item };
            
            $('#bloqueioModal').modal('show');

            this.$nextTick(() => { 
                this.abrindo = false;
            });
        },

        load () { 
            this.$util.load(this, { 
                service: 'bloqueios', 
                parms: { 
                    escopo: this.escopo, 
                    ...this.filtros, 
                    pesquisa: this.search,
                    cadastro: true, 
                    cc: this.cc, 
                    infusao: this.infusao, 
                    tipo_bloqueio: this.tipo_bloqueio, 
                }
            });
        }
    },

    mounted () {
        if ( this.infusao ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Infusão", path: "/infusao/planejamento" },
                { name: "Bloqueio", path: "/infusao/bloqueio" }
            ]);

        } else if ( this.cc ) { 

            this.$store.commit("setBreadcrumb", [
                { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
                { name: "Bloqueio", path: "/centro-cirurgico/bloqueio" }
            ]);

        } else { 

            this.$store.commit("setBreadcrumb", [
                { name: "Call Center", path: "/call-center" },
                { name: "Bloqueio", path: "/call-center/bloqueio" }
            ]);
            
        }

        this.load ();
    },

    updated () { 
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }
}
</script>